import utils from 'utils';
import tracker from 'utils/dio/zowie-chhatbot';
import apiKey from 'API/handlers/apiKey';

window.Chatbotize = undefined;

declare global {
  interface HTMLScriptElement {
    readyState: string;
    onreadystatechange: null | (() => void);
  }
}

const injectScript = () => {
  return new Promise((resolve) => {
    const scriptTag = document.createElement('script');
    const container = document.createElement('div');
    container.id = 'chatbotize';

    if (scriptTag.readyState) {
      scriptTag.onreadystatechange = () => {
        if (
          scriptTag.readyState === 'loaded' ||
          scriptTag.readyState === 'complete'
        ) {
          scriptTag.onreadystatechange = null;
          resolve(true);
        }
      };
    } else {
      scriptTag.onload = () => resolve(true);
    }

    scriptTag.src =
      'https://guesty.chat.getzowie.com/web/live-chat/chatbotize-entrypoint.min.js';
    document.body.appendChild(scriptTag);
    document.body.appendChild(container);
  });
};

const initZowieSetup = async () => {
  if (!window.Chatbotize) await injectScript();

  const {
    emailAddress,
    authenticatedData: { baseUserInfo },
  } = utils.getLocalStorageByKey(
    'emailAddress',
    'sessionToken',
    'authenticatedData'
  );

  const metadata = {
    email: emailAddress,
    firstName: baseUserInfo.firstName,
    lastName: baseUserInfo.lastName,
    extraParams: {
      apiKey: '',
      accountName: `${baseUserInfo.firstName} ${baseUserInfo.lastName}`,
      accountId: baseUserInfo.accountId,
    },
  };

  window.Chatbotize.init({
    instanceId: '7fa227e751d54ccb97383d0b24f4db73',
    headerMode: 'white',
    locale: 'en-US',
    allowFileUpload: true,
    showOnLoad: false,
    metadata,
    ...tracker,

    onOpen: async () => {
      tracker.onOpen?.();
      let apiKeyResponse = await apiKey.getApiKey(
        'CHATBOT',
        baseUserInfo.userId
      );
      if (!apiKeyResponse.data.apiKey) {
        apiKeyResponse = await apiKey.createApiKey(
          'CHATBOT',
          baseUserInfo.userId
        );
      }
      metadata.extraParams.apiKey = apiKeyResponse.data.apiKey;
      window.Chatbotize.updateMetadata(metadata);
    },
    onClose: () => {
      tracker.onClose?.();
      const event = new CustomEvent('ZowieOnClose');
      document.dispatchEvent(event);
    },
  });
};

export default initZowieSetup;
